<template>
    <div class="relative -m-6 bg-white">
      <LoadingModal
        heading="Loading Proposal"
        :loading="loading"/>

        <Calendar
            v-if="store.proposalReady && store.itineraryReady"
        />

      <settings v-if="store.proposalReady" />

      <destination-settings v-if="store.proposalReady && store.itineraryReady" />
        <notes v-if="store.proposalReady" />


        <!-- Proposal header -->
        <proposal-header :form="proposal_form" :proposal="proposal" />

        <!-- Featured bullets -->
        <featured-bullets :proposal="proposal" />

        <!-- Teaser -->
        <teaser :form="proposal_form" :proposal="proposal" />

        <!-- Highlights -->
        <highlights v-if="store.proposalReady && store.itineraryReady" />

        <!-- Destinations -->
        <destination v-if="store.proposalReady && store.itineraryReady" v-for="destination in proposal.places" :proposal="proposal" :destination="destination" />

        <!-- Image Gallery -->
        <gallery v-if="store.proposalReady" />

        <!-- Proposal Program -->
        <program v-if="store.proposalReady && store.itineraryReady" />

        <!-- Proposal Flights -->
        <flights v-if="store.proposalReady" :form="proposal_form"/>

        <!-- Summary -->
        <proposal-summary v-if="store.proposalReady" :form="proposal_form" />
    </div>
</template>

<script setup>

import {watch, reactive, onMounted, ref} from "vue";
import {notify} from "notiwind";
import Teaser from "@/Pages/Proposal/ShowOld/Teaser";
import FeaturedBullets from "@/Pages/Proposal/ShowOld/FeaturedBullets";
import ProposalHeader from "@/Pages/Proposal/ShowOld/ProposalHeader";
import Highlights from "@/Pages/Proposal/ShowOld/Highlights";
import Gallery from "@/Pages/Proposal/ShowOld/Gallery";
import Destination from "@/Pages/Proposal/ShowOld/Destination";
import Calendar from '@/Pages/Proposal/ShowOld/Calendar'
import { useProposalOldStore } from '@/Stores/ProposalOld'
import Program from "@/Pages/Proposal/ShowOld/Program";
import Notes from "@/Pages/Proposal/ShowOld/Notes";
import ProposalSummary from "@/Pages/Proposal/ShowOld/Summary";
import Flights from "@/Pages/Proposal/ShowOld/Flights";
import Settings from "@/Pages/Proposal/ShowOld/Settings";
import DestinationSettings from "@/Pages/Proposal/ShowOld/DestinationSettings";
import LoadingModal from "@/Components/Modals/LoadingModal.vue";

const props = defineProps({
    proposal: {
        type: Object,
        required: true
    }
})

const proposal_form = reactive(props.proposal);
const store = useProposalOldStore();

/* loading should only be active on first load */
const loading = ref(document.readyState === 'interactive' ?? false);

let timer;

onMounted(() => {
  store.setProposal(props.proposal);

  /* if first load, we need to stop loading when completed */
  document.onreadystatechange = () => {
    if (document.readyState === 'complete') {
      setTimeout(() => {
        loading.value = false;
      }, 500);
    }
  };
});

watch(proposal_form, () => {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  timer = setTimeout(() => {
    axios.post(route('api.proposal.store', {proposal: props.proposal.id}), proposal_form)
      .then(() => {
        notify({
          type: 'success',
          title: 'Saved',
          text: 'Proposal saved',
        }, 4000)
      }).catch(error => {
      notify({
        type: 'danger',
        title: 'Something went wrong',
        text: 'Could not save proposal',
      }, 4000)
      console.log(error)
    }).finally(() => {
    })
  }, 500)
})

</script>
